export default __webpack_public_path__ + "static/media/me.ae21a514.jpg";